import { AxiosResponse } from 'axios';
import api from './api';

export default {
  castrationByUid(uid: string): Promise<AxiosResponse> {
    return api.get(`/castrations/castration-by-uid/${uid}`);
  },
};
